<template>
  <div class="app-step-one">
    <div class="app-step-one__left">
      <el-form ref="formOne" label-width="90px" :model="formOne">
        <el-form-item
          label="推广城市"
          prop="marketingCityList"
          :rules="[{ type: 'array', required: true, message: '请至少选择一个推广城市', trigger: 'change' }]">
          <span class="app-step-one__selected" v-if="areasLabel.length">{{ areasLabel.join(', ') }}</span>
          <app-area-picker :defaultChecked="marketingCityList" @ok="onAreaPickerOk"></app-area-picker>
        </el-form-item>
        <template v-for="(item, index) in formOne.mainBusinessList">
          <div v-if="index > 0" class="app-step-one__line" :key="'hr' + index"></div>
          <el-form-item
            label="主营业务"
            :prop="'mainBusinessList.' + index + '.mainBusiness'"
            :rules="[{ required: true, message: '请输入主营业务', trigger: 'blur' }]"
            :key="index + '.mainBusiness'">
            <el-input v-model="item.mainBusiness" size="small" placeholder="请输入主营业务"></el-input>
          </el-form-item>
          <el-form-item
            label="业务细分"
            :prop="'mainBusinessList.' + index + '.businessList'"
            :rules="[{ required: true, message: '请输入业务细分', trigger: 'blur' }]"
            :key="index + '.businessList'">
            <el-input type="textarea" v-model="item.businessList" size="small" placeholder="请输入业务细分，业务的细分，请用逗号隔开"></el-input>
          </el-form-item>
          <el-form-item v-if="index === formOne.mainBusinessList.length - 1" :key="'btn' + index">
            <el-button type="info" size="small" @click="addServices" plain>继续添加主营业务</el-button>
            <el-button v-if="index > 0" type="text" size="small" @click="removeServices(index)">删除此条</el-button>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="app-step-one__right">
      <div class="app-step-one__example">
        <h5 class="app-step-one__example__title">参考示例</h5>
        <div class="app-step-one__example__content">
          <img src="@/assets/example-01.jpg" alt="示例">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppAreaPicker from '@/components/AppAreaPicker'

export default {
  name: 'AppStep',
  components: {
    AppAreaPicker
  },
  props: {
    marketingCityList: {
      type: Array,
      default: () => []
    },
    mainBusinessList: {
      type: Array,
      default: () => [{
        mainBusiness: '',
        businessList: ''
      }]
    }
  },

  data () {
    return {
      areasLabel: [],
      formOne: {
        marketingCityList: this.marketingCityList,
        mainBusinessList: this.mainBusinessList
      }
    }
  },

  created () {
    this.$on('validate', function () {
      this.submitForm((error, data) => {
        if (!error) {
          this.$emit('pass', data)
        }
      })
    })
  },

  methods: {
    submitForm (cb) {
      this.$refs.formOne.validate((valid) => {
        if (valid) {
          cb(null, this.formOne)
        } else {
          cb(new Error('validate error'), {})
          return false
        }
      })
    },

    addServices () {
      this.formOne.mainBusinessList.push({
        mainBusiness: '',
        businessList: ''
      })
    },

    removeServices (index) {
      this.formOne.mainBusinessList.splice(index, 1)
    },

    onAreaPickerOk (checkeds) {
      this.formOne.marketingCityList = checkeds.map(checked => checked.id)
      this.areasLabel = checkeds.map(checked => checked.label)
      this.$refs.formOne.validateField('marketingCityList')
    }
  }
}
</script>

<style lang="scss">
.app-step-one {
  display: flex;

  &__left,
  &__right {
    flex: 1;
  }

  &__left {
    padding-right: 30px;
    border-right: 1px solid $border-color;
  }

  &__right {
    padding-left: 30px;
  }

  &__example {
    padding: 15px 0;

    &__title {
      margin-top: 0;
      margin-bottom: 15px;
      color: #666;
    }

    &__content {
      width: 100%;
      padding: 10px;
      border: 1px dashed rgb(170, 206, 252);
      border-radius: 4px;
      background-color: rgb(218, 241, 255);

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  &__selected {
    display: inline-block;
    margin-right: 10px;
    color: $primary-color;
  }

  &__line {
    height: 1px;
    margin-bottom: 22px;
    background-color: #eee;
  }

  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }
}
</style>
